export enum URL {
  AUTHORIZE_TALENT = 'authenticate-talent',
  SET_TALENT_BREAK = 'v2/waitingroom/set-talent-brake',
  GET_FAN_QUESTIONNAIRE_ANSWERS = 'v2/waitingroom/get-questionnaire-by-bpsId',
}
